// ─── Qué le dice la pantalla de activación a quien no puede usar su enlace ──
// (defecto S, PM 2026-10-24) Antes, toda falla mostraba «Enlace inválido o
// expirado» y «¿Tu enlace expiró? Ingresa tu correo…», aunque el motivo fuera
// que ya se había usado o que había uno más reciente. Cada motivo pide algo
// distinto: pedir otro, iniciar sesión o buscar el último correo.
//
// UNA sola frase por motivo (defecto S, PM 2026-10-25): el título dice QUÉ
// pasó; la frase de abajo, QUÉ HACER. Antes había además un aviso rojo con el
// mensaje del servidor, que repetía lo mismo con otras palabras.

/** Por qué no se puede activar con este enlace. */
export type ActivationProblem =
  | 'not-found' // el token no existe
  | 'expired' // venció (7 días)
  | 'already-used' // ya se creó la contraseña con él
  | 'superseded' // se pidió otro después
  | 'reset-unusable' // enlace de «Olvidé mi contraseña» (1 h) vencido o usado
  | 'link-invalid'; // la dirección no trae ni token ni código

export interface ActivationCopy {
  /** Clave del título (ns auth). */
  title: string;
  /** La única frase bajo el título: qué hacer (ns auth). */
  hint: string;
  /** Ofrecer «Iniciar sesión» como acción principal (ya tiene contraseña). */
  suggestLogin: boolean;
}

export function activationCopy(problem: ActivationProblem): ActivationCopy {
  switch (problem) {
    case 'expired':
      return {
        title: 'activate.problem.expired.title',
        hint: 'activate.problem.expired.hint',
        suggestLogin: false,
      };
    case 'already-used':
      return {
        title: 'activate.problem.alreadyUsed.title',
        hint: 'activate.problem.alreadyUsed.hint',
        suggestLogin: true,
      };
    case 'superseded':
      return {
        title: 'activate.problem.superseded.title',
        hint: 'activate.problem.superseded.hint',
        suggestLogin: false,
      };
    case 'reset-unusable':
      return {
        title: 'activate.problem.resetUnusable.title',
        hint: 'activate.problem.resetUnusable.hint',
        suggestLogin: false,
      };
    case 'not-found':
    case 'link-invalid':
      return {
        title: 'activate.problem.invalid.title',
        hint: 'activate.problem.invalid.hint',
        suggestLogin: false,
      };
  }
}

/** Puntaje de la contraseña → la clave de su etiqueta y el color de la barra. */
export function strengthLook(score: number): { label: string; color: string } {
  if (score <= 1) return { label: 'activate.strength.veryWeak', color: '#ef4444' };
  if (score === 2) return { label: 'activate.strength.weak', color: '#f97316' };
  if (score === 3) return { label: 'activate.strength.fair', color: '#eab308' };
  if (score === 4) return { label: 'activate.strength.strong', color: '#22c55e' };
  return { label: 'activate.strength.veryStrong', color: '#10b981' };
}
